import { render, staticRenderFns } from "./Ventas.vue?vue&type=template&id=7250074c&"
import script from "./Ventas.vue?vue&type=script&lang=js&"
export * from "./Ventas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports